import { ModuleBase } from './base/module-base';

export class Module extends ModuleBase { }